// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2b20e","errorLogs":"EditorFooter_errorLogs__bJ7u1"};